import { Surface } from '@/ui/primitives';
import { tableV2NestedDepthSx, type TableV2NestedTableDepth } from './TableV2NestedTable';
import type { SurfaceBackground } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

const tableV2NestedSurfaceBackgroundByDepth = {
  1: 'page',
  2: 'primary',
  3: 'page',
  4: 'primary',
} satisfies Record<TableV2NestedTableDepth, SurfaceBackground>;

type TableV2NestedFrameProps = {
  children: ReactNode;
  depth: TableV2NestedTableDepth;
};

export const TableV2NestedFrame = ({ children, depth }: TableV2NestedFrameProps): ReactElement => (
  <Surface
    padding={null}
    radius="md"
    background={tableV2NestedSurfaceBackgroundByDepth[depth]}
    sx={tableV2NestedDepthSx[depth].frame}
  >
    {children}
  </Surface>
);
